export default {
  title: "Досие на пациент",
  systemIdTooltip: "Системен номер на пациента",
  copySystemId: "Копирай системен номер",
  actions: {
    refresh: "Обновяване",
  },
  tabs: {
    visits: "Визити",
    tests: "Изследвания",
  },
  visits: {
    empty: "Няма намерени визити за този пациент.",
    emptySubtitle: "Няма записани визити за този пациент.",
    idTooltip: "Идентификатор на визита",
    dateTooltip: "Дата и час на визита",
  },
  tests: {
    empty: "Няма намерени изследвания за този пациент.",
    emptySubtitle: "Няма записани изследвания за този пациент.",
    viewHistory: "Преглед на история",
    dateTooltip: "Дата и час на последния резултат",
  },
  errors: {
    patientNotFound: "Пациентът не е намерен",
    failedToLoad: "Грешка при зареждане на данните на пациента",
    // Patient info card error states
    patientServerTitle: "Нещо се обърка",
    patientServerSubtitle: "Грешка при зареждане на данните на пациента. Моля, опитайте отново.",
    patientNetworkTitle: "Загубена връзка",
    patientNetworkSubtitle: "Няма връзка със сървъра. Проверете интернет връзката си.",
    patientTimeoutTitle: "Времето за изчакване изтече",
    patientTimeoutSubtitle: "Сървърът отговаря твърде бавно. Моля, опитайте отново.",
    patientAuthTitle: "Сесията изтече",
    patientAuthSubtitle: "Моля, влезте отново, за да продължите.",
    patientUnknownTitle: "Неочаквана грешка",
    patientUnknownSubtitle: "Нещо се обърка. Моля, опитайте по-късно.",
    // Visits table error states
    visitsServerTitle: "Нещо се обърка",
    visitsServerSubtitle: "Грешка при зареждане на визитите. Моля, опитайте отново.",
    visitsNetworkTitle: "Загубена връзка",
    visitsNetworkSubtitle: "Няма връзка със сървъра. Проверете интернет връзката си.",
    visitsTimeoutTitle: "Времето за изчакване изтече",
    visitsTimeoutSubtitle: "Сървърът отговаря твърде бавно. Моля, опитайте отново.",
    visitsAuthTitle: "Сесията изтече",
    visitsAuthSubtitle: "Моля, влезте отново, за да продължите.",
    visitsUnknownTitle: "Неочаквана грешка",
    visitsUnknownSubtitle: "Нещо се обърка. Моля, опитайте по-късно.",
    // Tests table error states
    testsServerTitle: "Нещо се обърка",
    testsServerSubtitle: "Грешка при зареждане на изследванията. Моля, опитайте отново.",
    testsNetworkTitle: "Загубена връзка",
    testsNetworkSubtitle: "Няма връзка със сървъра. Проверете интернет връзката си.",
    testsTimeoutTitle: "Времето за изчакване изтече",
    testsTimeoutSubtitle: "Сървърът отговаря твърде бавно. Моля, опитайте отново.",
    testsAuthTitle: "Сесията изтече",
    testsAuthSubtitle: "Моля, влезте отново, за да продължите.",
    testsUnknownTitle: "Неочаквана грешка",
    testsUnknownSubtitle: "Нещо се обърка. Моля, опитайте по-късно.",
    retry: "Повторен опит",
    login: "Вход",
  },
};
